import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Button, Dialog, DialogTitle} from "@material-ui/core/";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import {TextField} from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import Close from "@material-ui/icons/Close";
import "./styles.css";

const RoiCalculator = (props) => {
    const {t} = useTranslation();
    const [resultValueDriverOne, setResultValueDriverOne] = useState(0);
    const [resultValueDriverTwo, setResultValueDriverTwo] = useState(0);
    const [resultValueDriverThree, setResultValueDriverThree] = useState(0);
    const [resultValueDriverFour, setResultValueDriverFour] = useState(0);
    const [resultRevenue, setResultRevenue] = useState({
        revenue: 0,
        total: 0,
        resultFines: 0,
        resultLost: 0,
        resultRisk: 0,
    });
    const [annual, setAnnual] = useState(0);
    const [revenueIncreases, setRevenueIncreases] = useState(0);
    const [savedRevenue, setSavedRevenue] = useState(0);
    const [fines, setFines] = useState(0);
    const [lostRevenue, setLostRevenue] = useState(0);
    const [valueDrivers, setValueDrivers] = useState([
        {
            resourcesTask: "0",
            averageSalary: "0",
            timeTask: "0",
            timeSaveProduct: "0",
            costResources: "0",
        },
    ]);
    const handleClose = () => {
        props.setOpen(false);
    };

    // increase
    function handleIncreaseValueDrivers() {
        if (valueDrivers.length < 4) {
            setValueDrivers((oldArr) => [
                ...oldArr,
                {
                    resourcesTask: "0",
                    averageSalary: "0",
                    timeTask: "0",
                    timeSaveProduct: "0",
                    costResources: "0",
                },
            ]);
        }
    }

    function handleValueControl(value = "") {
        if (value === "½") {
            value = "0.5";
        } else if (value === '%') {
            value = "";
        }

        return value.replace(/,/g, '.')
    }

    function handleChange(e, index, key) {
        setValueDrivers([
            ...valueDrivers.slice(0, index),
            Object.assign({}, valueDrivers[index], {[key]: handleValueControl(e.target.value)}),
            ...valueDrivers.slice(index + 1),
        ]);
    }

    //calculate
    function handleCalculate() {
        valueDrivers.forEach((item, index) => {
            if (index === 0) {
                let result =
                    Number(item.resourcesTask) *
                    Number(item.averageSalary) *
                    Number(Number(item.timeTask) / 100) *
                    (Number(item.timeSaveProduct) / 100) +
                    Number(item.costResources);
                setResultValueDriverOne(Number(result));
            } else if (index === 1) {
                let result =
                    Number(item.resourcesTask) *
                    Number(item.averageSalary) *
                    Number(Number(item.timeTask) / 100) *
                    (Number(item.timeSaveProduct) / 100) +
                    Number(item.costResources);
                setResultValueDriverTwo(Number(result));
            } else if (index === 2) {
                let result =
                    Number(item.resourcesTask) *
                    Number(item.averageSalary) *
                    Number(Number(item.timeTask) / 100) *
                    (Number(item.timeSaveProduct) / 100) +
                    Number(item.costResources);
                setResultValueDriverThree(Number(result));
            } else if (index === 3) {
                let result =
                    Number(item.resourcesTask) *
                    Number(item.averageSalary) *
                    Number(Number(item.timeTask) / 100) *
                    (Number(item.timeSaveProduct) / 100) +
                    Number(item.costResources);
                setResultValueDriverFour(Number(result));
            }
        });
        setResultRevenue({
            resultLost: Math.round(Number(annual) * (Number(lostRevenue) / 100)),
            total: Math.round(
                Number(annual) *
                (Number(revenueIncreases) / 100 + Number(savedRevenue) / 100)
            ),
            revenue: Math.round(
                Number(annual) *
                (Number(revenueIncreases) / 100 + Number(savedRevenue) / 100)
            ),
            resultRisk: Math.round(
                Number(Number(annual) * (Number(lostRevenue) / 100) + Number(fines))
            ),
            resultFines: Number(fines),
        });
    }

    function handleDelete(index) {
        let clone = valueDrivers.filter((item, indx) => indx !== index);
        setValueDrivers(clone);
    }

    function handleChangeInput(e, setState) {
        setState(handleValueControl(e.target.value));
    }

    return (
        <Dialog
            id="autom-addNew-modal"
            data-test="autom-add-new"
            open={true}
            PaperProps={{
                style: {
                    minWidth: 900,
                    minHeight: 600,
                },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                <div id="about-title">
                    {t("CONTENT.ROI.ROI-CALCULATOR")}
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close/>
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} style={{marginTop: 0, marginBottom: 0}}>
                    <Grid item xs={6}>
                        {/* <div className="roi-row-header">
              <span>Productivity</span>
            </div> */}
                        {valueDrivers.map((roiKey, index) => (
                            <div key={index}>
                                <div className="roi-row-drivers-header">
                                    <div>
                    <span>
                      {t("CONTENT.ROI.COST-REDUCTION")} #{index + 1}
                    </span>
                                    </div>
                                    {index === 0 ? (
                                        <div>
                                            <small style={{
                                                position: "relative",
                                                top: "-5px"
                                            }}>{t("CONTENT.ROI.UP-TO-4")}</small>
                                            <AddCircleOutlineIcon
                                                style={{
                                                    marginLeft: 5,
                                                    paddingLeft: 5,
                                                    paddingTop: 5,
                                                    color: "#8C90A2",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => handleIncreaseValueDrivers()}
                                            />
                                        </div>
                                    ) : (
                                        <HighlightOffIcon
                                            style={{
                                                paddingLeft: 5,
                                                paddingTop: 5,
                                                color: "#8C90A2",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => handleDelete(index)}
                                        />
                                    )}
                                </div>
                                <div className="roi-row">
                                    <div>
                                        <span>{t("CONTENT.ROI.RESOURCES-REQUIRED")}</span>
                                        <small>{t("CONTENT.ROI.NO-OF")}</small>
                                    </div>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        value={roiKey.resourcesTask}
                                        onChange={(e) => handleChange(e, index, "resourcesTask")}
                                    />
                                </div>
                                <div className="roi-row">
                                    <div>
                                        <span>{t("CONTENT.ROI.AVERAGE-ANNUAL")}</span>
                                    </div>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        value={roiKey.averageSalary}
                                        onChange={(e) => handleChange(e, index, "averageSalary")}
                                    />
                                </div>
                                <div className="roi-row">
                                    <div>
                                        <span>{t("CONTENT.ROI.TIME-TO-DO")}</span>
                                        <small>{t("CONTENT.ROI.AVERAGE")}</small>
                                    </div>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        value={roiKey.timeTask}
                                        onChange={(e) => handleChange(e, index, "timeTask")}
                                    />
                                </div>
                                <div className="roi-row">
                                    <div>
                                        <span>{t("CONTENT.ROI.TIME-SAVED")}</span>
                                        <small>{t("CONTENT.ROI.OF-COST")}</small>
                                    </div>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        value={roiKey.timeSaveProduct}
                                        onChange={(e) => handleChange(e, index, "timeSaveProduct")}
                                    />
                                </div>
                                <div className="roi-row">
                                    <div>
                                        <span>{t("CONTENT.ROI.COST-OF-OTHER")}</span>
                                        <small>{t("CONTENT.ROI.USER-LICENSES")}</small>
                                    </div>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        value={roiKey.costResources}
                                        onChange={(e) => handleChange(e, index, "costResources")}
                                    />
                                </div>
                            </div>
                        ))}
                        <div className="roi-row-drivers-header">
                            <span>{t("CONTENT.ROI.REVENUE-GENERATION")}</span>
                        </div>
                        <div className="roi-row">
                            <div>
                                <span>{t("CONTENT.ROI.ANNUAL-REVENUE")}</span>
                            </div>
                            <div>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    value={annual}
                                    onChange={(e) => handleChangeInput(e, setAnnual)}
                                />
                            </div>
                        </div>
                        <div className="roi-row">
                            <div>
                                <span>{t("CONTENT.ROI.REVENUE-INCREASES")}</span>
                                <small>{t("CONTENT.ROI.INCREASE-IN-REVENUE")}</small>
                            </div>
                            <div>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    value={revenueIncreases}
                                    onChange={(e) => handleChangeInput(e, setRevenueIncreases)}
                                />
                            </div>
                        </div>
                        <div className="roi-row">
                            <div>
                                <span>{t("CONTENT.ROI.SAVED-REVENUE")}</span>
                                <small>{t("CONTENT.ROI.LOSS-AVOIDED")}</small>
                            </div>
                            <div>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    value={savedRevenue}
                                    onChange={(e) => handleChangeInput(e, setSavedRevenue)}
                                />
                            </div>
                        </div>
                        <div className="roi-row-drivers-header">
                            <span>{t("CONTENT.ROI.RISK-AVOIDANCE")}</span>
                        </div>
                        <div className="roi-row">
                            <div>
                                <span>{t("CONTENT.ROI.ANNUAL-REVENUE")}</span>
                            </div>
                            <div>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    value={annual}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="roi-row">
                            <div>
                                <span>{t("CONTENT.ROI.FINES-AVOIDED")}</span>
                            </div>
                            <div>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    value={fines}
                                    onChange={(e) => handleChangeInput(e, setFines)}
                                />
                            </div>
                        </div>
                        <div className="roi-row">
                            <div>
                                <span>{t("CONTENT.ROI.LOST-REVENUE")}</span>
                                <small>{t("CONTENT.ROI.LOSS-AVOIDED")}</small>
                            </div>
                            <div>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    value={lostRevenue}
                                    onChange={(e) => handleChangeInput(e, setLostRevenue)}
                                />
                            </div>
                        </div>
                        <DialogActions
                            style={{
                                justifyContent: "center",
                                padding: "8px 24px 16px 24px",
                                margin: 20,
                            }}
                        >
                            <Button
                                variant="outlined"
                                style={{
                                    backgroundColor: "#162436",
                                    borderRadius: "4px",
                                    color: "#fff",
                                    width: "100px",
                                    border: "none",
                                    fontSize: 12,
                                }}
                                onClick={() => handleCalculate()}
                            >
                                {t("CONTENT.ROI.CALCULATE")}
                            </Button>
                        </DialogActions>
                    </Grid>
                    <Grid item xs={6} className="roi-right-side">
                        <div className="roi-drivers-header">
                            <span>{t("CONTENT.ROI.COMPUTATION")}</span>
                        </div>
                        <div className="roi-row">
                            <span>{t("CONTENT.ROI.COST-REDUCTION")}#1</span>
                            <TextField
                                variant="outlined"
                                size="small"
                                disabled
                                value={Math.round(resultValueDriverOne)}
                            />
                        </div>
                        <div className="roi-row">
                            <span>{t("CONTENT.ROI.COST-REDUCTION")}#2</span>
                            <TextField
                                variant="outlined"
                                size="small"
                                disabled
                                value={Math.round(resultValueDriverTwo)}
                            />
                        </div>
                        <div className="roi-row">
                            <span>{t("CONTENT.ROI.COST-REDUCTION")}#3</span>
                            <TextField
                                variant="outlined"
                                size="small"
                                disabled
                                value={Math.round(resultValueDriverThree)}
                            />
                        </div>
                        <div className="roi-row">
                            <span>{t("CONTENT.ROI.COST-REDUCTION")}#4</span>
                            <TextField
                                variant="outlined"
                                size="small"
                                disabled
                                value={Math.round(resultValueDriverFour)}
                            />
                        </div>
                        <div className="roi-row-total">
                            <div className="roi-drivers-header">
                                <span>{t("CONTENT.ROI.PRODUCTIVITY-COST")}(a)</span>
                            </div>
                            <span className="roi-drivers-header-total">
                {Math.round(
                    resultValueDriverOne +
                    resultValueDriverFour +
                    resultValueDriverThree +
                    resultValueDriverTwo
                )}
              </span>
                        </div>
                        <div className="roi-row">
                            <span>{t("CONTENT.ROI.REVENUE-GENERATION-DRIVER")}</span>
                            <TextField
                                variant="outlined"
                                size="small"
                                disabled
                                value={resultRevenue.revenue}
                            />
                        </div>
                        <div className="roi-row-total">
                            <div className="roi-drivers-header">
                                <span>{t("CONTENT.ROI.PRODUCTIVITY-COST")}(b)</span>
                            </div>
                            <span className="roi-drivers-header-total">
                {resultRevenue.total}
              </span>
                        </div>
                        <div className="roi-row">
                            <span>{t("CONTENT.ROI.FINES-AVOIDED")}</span>
                            <TextField
                                variant="outlined"
                                size="small"
                                disabled
                                value={resultRevenue.resultFines}
                            />
                        </div>
                        <div className="roi-row">
                            <span>{t("CONTENT.ROI.LOST-REVENUE")}</span>
                            <TextField
                                variant="outlined"
                                size="small"
                                disabled
                                value={resultRevenue.resultLost}
                            />
                        </div>
                        <div className="roi-row-total">
                            <div className="roi-drivers-header">
                                <span>{t("CONTENT.ROI.COST-AVOIDED-REVENUE")}(c)</span>
                            </div>
                            <span className="roi-drivers-header-total">
                {resultRevenue.resultRisk}
              </span>
                        </div>
                        <div className="roi-drivers-header">
                            <span>{t("CONTENT.ROI.TOTAL")}( a + b + c )</span>
                            <TextField
                                variant="outlined"
                                size="small"
                                disabled
                                value={Math.round(
                                    resultRevenue.resultRisk +
                                    resultValueDriverThree +
                                    resultValueDriverTwo +
                                    resultValueDriverOne +
                                    resultValueDriverFour
                                )}
                            />
                        </div>
                        <hr/>
                        <div className="roi-row">
                            <small>
                                {t("CONTENT.ROI.EXP-1")}
                                <b>{t("CONTENT.ROI.EXP-2")}</b>
                                {t("CONTENT.ROI.EXP-3")}
                            </small>
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default RoiCalculator;
